// Opened in a new tab from the Help & Support panel; the in-app links live in WelcomeCard
export const HELP_CENTER_LINK = {
  SUBMIT_TICKET: 'https://dashboard.swymo.ai/help',
  INBODY_MACHINE_AND_DATA:
    'https://docs.google.com/document/d/1jmT5Dnw1sejub9ZCh1LxtjGgP8iED2I8p0rJpryB32M/edit?tab=t.0#heading=h.9exefxw3yfmp',
  RESULTS_GUIDE: 'https://drive.google.com/file/d/17dt8DGEOuC6Q5-Fwa4wVCv6uvmCwjxQ6/view',
} as const;
